export const getSubdomain = (): string => {
  const hostname = window.location.hostname;

  // Para desarrollo local — detectar por puerto
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    const port = window.location.port;
    if (port === '5172') return 'user';
    if (port === '5173') return 'admin';
    // Fallback: query param ?app=user|admin|landing
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('app') || 'landing';
  }

  // Extraer subdominio del hostname (funciona para cualquier dominio)
  const parts = hostname.split('.');
  if (parts.length >= 2) {
    const subdomain = parts[0];
    switch (subdomain) {
      case 'app':
        return 'user';
      case 'adm':
        return 'admin';
      default:
        return 'landing';
    }
  }

  // Default
  return 'landing';
};

export const getAppType = () => {
  return getSubdomain();
};
